const faqs = [
  {
    q: '91电影平台上的内容是否免费？',
    a: '91电影作为一个国产电影推荐聚合平台，所有推荐内容均为免费浏览。我们提供的影片信息、评分、推荐理由均为公开内容，用户无需付费即可查看。实际影片观看请通过正规渠道。',
  },
  {
    q: '国产91电影的推荐频率是怎样的？',
    a: '我们坚持每日更新推荐内容，编辑团队每天筛选最新国产大片和口碑好片进行推荐。同时每周发布热门榜单和专题合集，帮助你及时了解国产电影最新动态。',
  },
  {
    q: '平台上推荐的电影类型有哪些？',
    a: '91电影覆盖悬疑、动作、喜剧、文艺、科幻、历史、动画、纪录片等多种类型。从院线热门到独立佳作，从经典老片到最新上映，类型丰富，满足不同观众口味。',
  },
  {
    q: '如何在手机上使用91电影？',
    a: '91电影已针对移动端进行全面适配，你只需在手机浏览器中打开即可获得流畅的浏览体验。页面布局会根据屏幕尺寸自动调整，方便随时随查看最新电影推荐。',
  },
  {
    q: '推荐的电影评分来自哪里？',
    a: '我们的评分综合了专业影评人评价、观众口碑反馈以及平台编辑团队的独立评审。每部电影的评分都经过多方参考，力求客观公正地反映影片质量。',
  },
  {
    q: '我可以向平台推荐好电影吗？',
    a: '当然可以！欢迎通过页面底部联系区域与我们取得联系，分享你发现的优质国产电影。我们的编辑团队会认真评估每一条推荐，优秀的内容有机会被收录到精选推荐中。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于91电影的常见问题，快速了解我们
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden"
              open={idx === 0}
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 pr-4">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-500 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-5 h-5 items-center justify-center text-foreground-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}